import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/library/blocks/images/NextImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/entities/common/components/SearchInput.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/library/entities/socialize/bookmark/Bookmark.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/utils/formatters/MomentClient.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
